import {Transition, TransitionChild} from "@headlessui/react";

export const Modal = ({children, isOpen, zIndex = "z-[100]"}) => {
    return (
        <Transition show={isOpen}>
            <div
                className={`min-h-[100dvh] h-[100dvh] max-h-[100dvh] w-screen flex items-center justify-center 
                    fixed inset-0 ${zIndex}
                    bg-black/75 backdrop-blur-sm
                    data-[closed]:opacity-0
                    data-[enter]:duration-75 data-[enter]:data-[closed]:ease-out
                    data-[leave]:duration-300 data-[leave]:data-[closed]:ease-out`}
            >
                <TransitionChild>
                    <div
                        className="h-fit max-h-[100vh]
                            min-w-[40vw] max-w-[90vw]
                            portrait:min-h-full portrait:h-full portrait:max-h-full
                            portrait:min-w-[100dvw] portrait:w-[100dvw] portrait:max-w-[100dvw]
                            portrait:md:h-fit portrait:md:min-w-[40vw] portrait:md:max-w-[90vw]
                            transform z-50 rounded-xl flex items-center justify-center
                            data-[enter]:duration-100 data-[enter]:data-[closed]:scale-75
                            data-[leave]:duration-300 data-[leave]:data-[closed]:scale-95"
                    >
                        {children}
                    </div>
                </TransitionChild>
            </div>
        </Transition>
    )
}
